import { createHtmlElement } from '../utility/dom-util';
/**
 * canvas renderer
 */
/** @private */
export class BarcodeCanvasRenderer {
    /**
     * Get the context value for the canvas.\
     *
     * @returns {CanvasRenderingContext2D} Get the context value for the canvas .
     * @param {HTMLCanvasElement} canvas - Provide the canvas element .
     * @private
     */
    static getContext(canvas) {
        return canvas.getContext('2d');
    }
    /**
     * Draw the root element for the barcode.\
     *
     * @returns {HTMLElement} Draw the barcode SVG .
     * @param {Object} attribute - Provide the canvas element .
     * @param {string} backGroundColor - Provide the canvas element .
     * @param {number} width - Provide the canvas element .
     * @param {number} height - Provide the canvas element .
     * @private
     */
    // eslint-disable-next-line
    renderRootElement(attribute, backGroundColor, width, height) {
        const canvasObj = createHtmlElement('canvas', attribute);
        const ctx = canvasObj.getContext('2d');
        ctx.fillStyle = backGroundColor;
        ctx.fillRect(0, 0, width, height);
        return canvasObj;
    }
    /**
     * Draw the rect for the barcode.\
     *
     * @returns {HTMLElement} Draw the barcode SVG .
     *  @param {Object} canvas - Provide the canvas element .
     *  @param {Object} attribute - Provide the canvas element .
     * @private
     */
    renderRect(canvas, attribute) {
        const ctx = canvas.getContext('2d');
        if (attribute.imageSource) {
            const image = new Image();
            image.src = attribute.imageSource;
            image.onload = function () {
                ctx.drawImage(image, attribute.x, attribute.y, attribute.width, attribute.height);
            };
        }
        else {
            ctx.fillStyle = attribute.color;
            ctx.fillRect(attribute.x, attribute.y, attribute.width, attribute.height);
        }
        return canvas;
    }
    /**
     * Draw the text for the barcode.\
     *
     * @returns {HTMLElement} Draw the barcode SVG .
     *  @param {Object} canvas - Provide the canvas element .
     *  @param {Object} attribute - Provide the canvas element .
     * @private
     */
    renderText(canvas, attribute) {
        const ctx = canvas.getContext('2d');
        ctx.save();
        ctx.font = (attribute.stringSize) + 'px ' + attribute.fontStyle;
        ctx.fillStyle = attribute.color;
        ctx.fillText(attribute.string, attribute.x, attribute.y);
        return canvas;
    }
}
